var map = {
	"./CB0000_rabbit.png": "3ead",
	"./CB0000_rabbit_stroke.png": "6bc1",
	"./CB0010_bear.png": "f3dd",
	"./CB0010_bear_stroke.png": "9e71",
	"./CB0020_cat.png": "ce2d",
	"./CB0020_cat_stroke.png": "f8a6",
	"./CB0030_hamster.png": "c924",
	"./CB0030_hamster_stroke.png": "04bf",
	"./CC0000_default.png": "04f4",
	"./CE0000_default.png": "07f7",
	"./CE0000_default_F1.png": "ac4c",
	"./CH0000_default.png": "eef1",
	"./CM0000_rabbit.png": "d813",
	"./CM0010_bear.png": "ad90",
	"./CM0020_cat.png": "ad68",
	"./CM0030_hamster.png": "ec41",
	"./CS0000_default.png": "2bed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "daca";